/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { NgModule } from '@angular/core';
import { environment } from 'environments/environment';
import { StoreModule, Action } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { UserAuthApiEffects, UserAuthState, reducer, INITIAL_STATE } from './store';
import { UserAuthEffects } from './store/user-auth.effects';
import { AuthService } from './services/auth.service';
import { Auth0AuthService } from './services/auth0-auth.service';
import { MockAuthService } from './services/mock-auth.service';
import { flattenReducers } from 'app/shared/store/utils';

@NgModule({
  declarations: [],
  imports: [
    StoreModule.forFeature('user-auth', userAuthReducer),
    EffectsModule.forFeature([UserAuthApiEffects, UserAuthEffects])
  ],
  providers: [{ provide: AuthService, useFactory: authServiceFactory }]
})
export class UserAuthModule {}

// -------------------------------------------------------------------------
/** The flattened reducer for the user auth state. */
export function userAuthReducer(state: UserAuthState, action: Action): UserAuthState {
  return flattenReducers(INITIAL_STATE, reducer)(state, action);
}

/** Provides the auth data service. */
export function authServiceFactory(): AuthService {
  if (environment.disableAuth) {
    return new MockAuthService();
  }
  return new Auth0AuthService();
}
